import { supabase } from '@/lib/safeSupabase';

/**
 * Log an audit event (5-param form).
 *
 * @param action   - e.g. 'scenario.created', 'user.suspended'
 * @param orgId    - explicit org id (pass null when not applicable)
 * @param targetType - e.g. 'scenario', 'user', 'organization'
 * @param targetId - id of the affected entity
 * @param details  - arbitrary metadata
 */
export function logAudit(
  action: string,
  orgId: string | null | undefined,
  targetType?: string,
  targetId?: string,
  details?: Record<string, any>,
) {
  supabase
    .rpc('log_audit', {
      p_action: action,
      p_org_id: orgId ?? null,
      p_target_type: targetType ?? null,
      p_target_id: targetId ?? null,
      p_details: details ?? {},
    })
    .then(() => {});
}

/**
 * Creates a 4-param logAudit pre-bound to a specific orgId.
 * Useful in org-scoped components where every call shares the same org.
 */
export function createOrgLogger(orgId: string | null | undefined) {
  return (action: string, targetType?: string, targetId?: string, details?: Record<string, any>) =>
    logAudit(action, orgId, targetType, targetId, details);
}
